import { Activity } from '@cube3/common/model/schema/resources/activities';
import { getChangedValue } from './getActivityConfig';

export const makeActivityListUI = (activities: Activity[]) => {
  if (!activities?.length) return [];
  return activities?.map((act) => {
    switch (act.action) {
      case 'AssetCreated':
      case 'FolderCreated':
      case 'ApprovalCreated':
      case 'CommentCreated':
        return {
          ...act,
          oldValue: getChangedValue(act)?.newVal // the old message/status/name that was modified
        };

      default:
        return act;
    }
  });
};
